<template>
  <div class="card" :class="{'modal-card': prorataTemporisDateQuantite}">
    <div class="pd-0" :class="{'modal-card-body': prorataTemporisDateQuantite}">
      <header class="bandeau-modal card-header">
      </header>
      <div class="card-content">
        <error-msg-component :messages="messagesPopup"
                             :error="isError"
                             :title="'dateDevis.error.title'"
                             :withEmplyFields="true"
                             @close="isError = $event"/>
        <p class="is-size-3 has-text-weight-bold mgb-20px has-text-centered">
          {{ $t('dateDevis.header')}}
        </p>
        <information-msg-component
          v-if="messagesInformation.length > 0"
          :libelleList="messagesInformation"
          title="dateDevis.info">
        </information-msg-component>
        <div class="columns is-marginless is-paddingless card-content is-vcentered">
          <div class="column is-narrow pdl-0">
            <b-field :label="$t('dateDevis.date.du')">
            </b-field>
          </div>
          <b-datepicker show-week-number class="column is-narrow"
                        @input="updateQuantiteByProrataDate()"
                        v-model="dateDebut"
                        icon="calendar-today"
                        nearby-selectable-month-days
                        :editable="true"
                        :disabled="ligneRegroupement.isAffecteLogistiquement">
          </b-datepicker>
          <div class="column is-narrow">
            <b-field :label="$t('dateDevis.date.au')">
            </b-field>
          </div>
          <div class="column is-narrow">
            <b-datepicker show-week-number
                          v-model="dateFin"
                          icon="calendar-today"
                          nearby-selectable-month-days
                          position="is-bottom-left"
                          @input="onUpdateDateFin()"
                          :editable="true">
            </b-datepicker>
          </div>
        </div>
        <div class="columns is-marginless is-paddingless card-content is-vcentered"
             v-if="isFromLogistique && ligneRegroupement.typeProduit === categorieUnitaire">
          <div class="column is-12 is-paddingless has-text-default">
            {{ $t('editionCommande.logistique.posePlanification') }}
            {{ formatDate(ligneRegroupement.datePlanifieeLogistiqueAffichage) }}
          </div>
        </div>
        <div class="columns mgt-10px mgb-0"
             v-if="avecMajDateRenouvellement && !isCommandeBailleur">
          <div class="column is-12">
            <b-checkbox v-model="changeDateRenouvellement">
              {{ $t('dateDevis.majDateRenouvelement') }}
            </b-checkbox>
          </div>
        </div>
        <div class="columns" :class="{'mgt-10px': !avecMajDateRenouvellement}"
             v-if="!isFirstTime && !isFromLogistique">
          <div class="column is-12">
            <b-checkbox v-model="prorataTemporisDateQuantite">
              {{ $t('dateDevis.majQuantiteProrataTemporis') }}
            </b-checkbox>
          </div>
        </div>
        <div class="columns mgt-10px"  v-if="existTfsAffecteeApresDateFin">
          <div class="column is-12">
            <qd-switch v-model="isDeleteTfsAfterEndDate">
              {{ $t('dateDevis.deleteTfsAfterDateFin') }}
            </qd-switch>
          </div>
        </div>
        <div class="columns is-vcentered" v-if="prorataTemporisDateQuantite && !isFirstTime
        && !isFromLogistique">
          <div class="column is-narrow">
            {{ $t('dateDevis.nouvelleQuantite') }}
          </div>
          <div class="column is-4">
            <input-currency v-model="newQuantite" isNumber="true"
                            @input="repercutionModificationQuantite($event)"></input-currency>
          </div>
        </div>
        <div class="overflow-x-hidden"
             :class="[{'is-height-250px': ligneWithQuantiteEditable.length > 2
        && prorataTemporisDateQuantite},
             {'overflow-y-auto': ligneWithQuantiteEditable.length > 2
             && prorataTemporisDateQuantite}]" v-if="!isFirstTime && !isFromLogistique">
          <v-client-table :data="ligneWithQuantiteEditable" :columns="columns"
                          class="displayNoneVuePagination"
                        :options="options" ref="tableRole" v-if="prorataTemporisDateQuantite">
          <div slot="selected" slot-scope="props">
            <b-checkbox :value="props.row.quantiteDoitEtreProratise"
                        class="mgt-5px"
                        @input="activationCalculProrata(props.row.ordre, $event)">
            </b-checkbox>
          </div>
          <div slot="libelle" slot-scope="props">
            <p class="mgt-5px">{{ props.row.libelle }}</p>
          </div>
          <div slot="quantite" slot-scope="props">
            <input-currency v-model="props.row.quantite"
              :disabled="!props.row.quantiteDoitEtreProratise"
              :checkBlur="true"
              @catchBlur="updateKeyValueOfLigne('quantite', props.row.ordre, props.row.quantite)">
            </input-currency>
          </div>
          <div slot="prixUnitaire" slot-scope="props">
            <input-currency v-model="props.row.prixUnitaire"
              :disabled="!props.row.quantiteDoitEtreProratise"
              :checkBlur="true"
              @catchBlur="updateKeyValueOfLigne('prixUnitaire', props.row.ordre,
                props.row.prixUnitaire)">
            </input-currency>
          </div>
          <div slot="montantBrut" slot-scope="props">
            <input-currency v-model="props.row.montantBrut"
              :disabled="!props.row.quantiteDoitEtreProratise"
              :checkBlur="true"
              @catchBlur="updateQuantiteWithMontantBrut(props.row.ordre, props.row.montantBrut)">
            </input-currency>
          </div>
        </v-client-table>
        </div>
        <main class="mgt-20px">
          <div class="is-grouped">
            <button
              class="button btn-modal-annuler is-cancel button-modal-decision"
              @click="$parent.close">
              {{ $t('dateDevis.button.cancel')}}
            </button>
            <button class="button is-addOrEdit button-modal-decision mgl-20px"
                    @click="sendEvent()">
              {{ $t('dateDevis.button.validate')}}
            </button>
          </div>
        </main>
      </div>
    </div>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import validationDateLocation from '@/services/devisCommandes/validation/validationDateLocation';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import informationMsgComponent from '@/components/general/informationMsgComponent';
import formatDate from '@/services/general/formatDate';
import { COMMANDER } from '@/configuration/affectation/affectationConf';
import { CATEGORIE_UNITAIRE, CATEGORIE_REGROUPEMENT_LC, CATEGORIE_DIVERS } from '@/configuration/catalogue/produitConf';
import { REGIE } from '@/configuration/societe/societe';
import {
  TYPE_FACTURE, LOCATION, NORMAL, REGROUPEMENT, MODULE_BAIL, SENS_ACHAT,
} from '@/configuration/devisConf';
import calculDaysBetweenTwoDate from '@/services/general/calculDaysBetweenTwoDate';
import calculArrondi from '@/services/calcul/calculArrondi';
import inputCurrency from '@/components/general/inputCurrency';
import {
  NO_PER_PAGE_VALUE, NO_PAGINATION, SORT_ICON, TEXTS,
} from '@/configuration/clientTableConf';
import getDateWithAnneeSemaineAndJourDepart
  from '@/services/general/getDateWithAnneeSemaineAndJourDepart';
import moment from 'moment';
import {
  mettreAJourLigneReseauAvecDispo,
} from '@/services/devisCommandes/ajoutProduit/ajoutProduitReseauLc';

export default {
  props: {
    avecMajDateRenouvellement: {
      type: Boolean,
      default: false,
    },
    ligneRegroupement: Object,
    devisCommande: {
      type: Object,
      required: true,
    },
    isFromLogistique: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    inputCurrency,
    errorMsgComponent,
    informationMsgComponent,
  },
  data() {
    return {
      isError: false,
      categorieUnitaire: CATEGORIE_UNITAIRE,
      categorieRegroupementLc: CATEGORIE_REGROUPEMENT_LC,
      messagesInformation: [],
      messagesPopup: [],
      changeDateRenouvellement: this.avecMajDateRenouvellement,
      dateDebut: cloneDeep(this.ligneRegroupement.dateDebut),
      dateFin: cloneDeep(this.ligneRegroupement.dateFin),
      prorataTemporisDateQuantite: false,
      isFirstTime: false,
      newQuantite: null,
      ligneWithQuantiteEditable: [],
      isDeleteTfsAfterEndDate: true,
    };
  },
  computed: {
    columns() {
      return [
        'selected',
        'libelle',
        'quantite',
        'prixUnitaire',
        'montantBrut',
      ];
    },
    allLigneSelected() {
      return this.ligneWithQuantiteEditable.length > 0
        && !this.ligneWithQuantiteEditable.some(ligne => !ligne.quantiteDoitEtreProratise);
    },
    iconSelectTotal() {
      if (this.allLigneSelected) return 'checkbox-multiple-marked-outline';
      return 'checkbox-multiple-blank-outline';
    },
    options() {
      const texts = cloneDeep(TEXTS);
      texts.count = '';
      return {
        sortIcon: SORT_ICON,
        headings: {
          libelle: this.$t('dateDevis.tab.libelle'),
          prixUnitaire: this.$t('dateDevis.tab.prixUnitaire'),
          montantBrut: this.$t('dateDevis.tab.montantBrut'),
          quantite: this.$t('dateDevis.tab.quantite'),
          selected: (h) => {
            return h(
              'a', {
                attrs: {
                  class: 'pointer',
                },
                on: {
                  click: () => {
                    const allSelected = this.allLigneSelected;
                    this.ligneWithQuantiteEditable.forEach(ligne => {
                      ligne.quantiteDoitEtreProratise = !allSelected;
                      this.activationCalculProrata(ligne.ordre, !allSelected);
                    });
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: this.iconSelectTotal,
                  },
                }),
              ],
            );
          },
        },
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: NO_PAGINATION,
        texts: texts,
        filterable: false,
        columnsClasses: {
          selected: 'colonneSelected-35',
          libelle: 'is-prewrap is-word-break max-width-300px',
          quantite: 'max-width-110',
          prixUnitaire: 'max-width-110',
          montantBrut: 'max-width-110',
        },
        sortable: ['libelle', 'quantite', 'prixUnitaire', 'montantBrut'],
      };
    },
    existTfsAffecteeApresDateFin() {
      return this.ligneRegroupement.tfsAffectees?.length > 0
      && this.ligneRegroupement.tfsAffectees.some(tfs => {
        const date = getDateWithAnneeSemaineAndJourDepart(tfs.anneeSemaine, 7);
        return date > this.dateFin;
      });
    },
    isCommandeBailleur() {
      return this.devisCommande.module === MODULE_BAIL && this.devisCommande.sens === SENS_ACHAT;
    },
  },
  methods: {
    miseEnformelibelle() {
      const messages = [];
      if (this.ligneRegroupement.isAffecteLogistiquement) {
        messages.push({
          libelle: this.$t('dateDevis.error.faceAffecteeLogistiquement'),
          isLink: false,
        });
      }
      if (this.ligneRegroupement.typeProduit === this.categorieUnitaire
        && !this.ligneRegroupement.produit.actif) {
        messages.push({
          libelle: this.$t('dateDevis.error.produitArchive'),
          isLink: false,
        });
      }
      if ((!(this.ligneRegroupement.typeProduit === this.categorieUnitaire)
          && !(this.ligneRegroupement.typeProduit === this.categorieRegroupementLc))
        || this.ligneRegroupement.affectation === undefined
        || this.ligneRegroupement.affectation.length === 0) {
        return messages;
      }
      messages.push({
        libelle: this.ligneRegroupement.typeProduit === CATEGORIE_UNITAIRE ? this.$t('dateDevis.error.faceAffecte') : this.$t('dateDevis.error.reseauAffecte'),
        isLink: false,
      });
      this.ligneRegroupement.affectation.forEach((affectationDuProduit) => {
        const type = affectationDuProduit.typeReference === COMMANDER ? this.$t('dateDevis.affectation.commande') : this.$t('dateDevis.affectation.reseau');
        const newMessage = {
          libelle: this.$t('dateDevis.libelleLink', {
            type: type,
            libelle: affectationDuProduit.libelle,
            dateDebut: formatDate(affectationDuProduit.dureeAffectation.dateDebut),
            dateFin: formatDate(affectationDuProduit.dureeAffectation.dateFin),
          }),
          isLink: true,
          id: affectationDuProduit.referenceId,
          routeName: affectationDuProduit.typeReference === COMMANDER ? 'c.bodac.commandes' : 'c.bodac.catalogue-reseau',
        };
        messages.push(newMessage);
      });
      return messages;
    },
    getMontantBrut(ligne) {
      return calculArrondi(ligne.quantite * ligne.prixUnitaire, 2);
    },
    activationCalculProrata(ordre, value) {
      const ligneFind = this.ligneWithQuantiteEditable.find((ligne) => {
        return ligne.ordre === ordre;
      });
      ligneFind.quantiteDoitEtreProratise = value;
      if (ligneFind.quantiteDoitEtreProratise) {
        ligneFind.quantite = this.newQuantite;
        ligneFind.montantBrut = this.getMontantBrut(ligneFind);
        return;
      }
      const ligneEnfantOrigine = this.ligneRegroupement.lignesCommande
        .find((ligneEnfantOrigine) => {
          return ligneEnfantOrigine.ordre === ordre;
        });
      ligneFind.quantite = ligneEnfantOrigine.quantite;
      ligneFind.prixUnitaire = ligneEnfantOrigine.prixUnitaire;
      ligneFind.montantBrut = this.getMontantBrut(ligneEnfantOrigine);
    },
    repercutionModificationQuantite(newQuantite) {
      this.ligneWithQuantiteEditable.forEach((ligne) => {
        if (ligne.quantiteDoitEtreProratise) {
          ligne.quantite = newQuantite !== null ? newQuantite : 0;
          ligne.montantBrut = this.getMontantBrut(ligne);
        }
      });
    },
    updateQuantiteWithMontantBrut(ordre, value) {
      const ligneFind = this.ligneWithQuantiteEditable.find((ligne) => {
        return ligne.ordre === ordre;
      });
      if (!ligneFind || ligneFind.prixUnitaire === 0 || !value) return;
      ligneFind.quantite = calculArrondi(value / ligneFind.prixUnitaire, 10);
      ligneFind.montantBrut = this.getMontantBrut(ligneFind);
    },
    updateKeyValueOfLigne(key, ordre, value) {
      const ligneFind = this.ligneWithQuantiteEditable.find((ligne) => {
        return ligne.ordre === ordre;
      });
      if (!ligneFind) return;
      ligneFind[key] = value;
      ligneFind.montantBrut = this.getMontantBrut(ligneFind);
    },
    setLigneOfRegroupement(lignes) {
      const ligneWithQuantiteEditable = lignes
        .filter((ligneEnfant) => {
          return !ligneEnfant.calculAutomatiqueTlpe;
        });
      ligneWithQuantiteEditable.forEach((ligne) => {
        ligne.quantiteDoitEtreProratise = (ligne.typeProduit === LOCATION
          || (ligne.typeProduit === CATEGORIE_DIVERS && ligne.produit.produitDivers.tlpe))
          && ligne.type === NORMAL;
        ligne.montantBrut = calculArrondi(ligne.prixUnitaire * ligne.quantite);
      });
      this.ligneWithQuantiteEditable = ligneWithQuantiteEditable;
    },
    onUpdateDateFin() {
      this.updateQuantiteByProrataDate();

      const msgAffectationApresDateFin = {
        libelle: this.$t('dateDevis.error.warningAffectationsApresDateFin'),
        isLink: false,
      };
      const messageExistant = this.messagesInformation
        .some(msg => msg.libelle === msgAffectationApresDateFin.libelle);

      if (this.existTfsAffecteeApresDateFin && !messageExistant) {
        this.messagesInformation.push(msgAffectationApresDateFin);
      } else if (!this.existTfsAffecteeApresDateFin && messageExistant) {
        this.messagesInformation = this.messagesInformation
          .filter(msg => msg.libelle !== msgAffectationApresDateFin.libelle);
      }
    },
    updateQuantiteByProrataDate() {
      if (!this.prorataTemporisDateQuantite) return;
      const ligneEnfantLocation = this.ligneRegroupement.lignesCommande.find((ligneEnfant) => {
        return ligneEnfant.type === NORMAL && ligneEnfant.typeProduit === LOCATION;
      });
      if (!ligneEnfantLocation) return;

      const nombreJourEntreDebutFin = Number(
        (calculDaysBetweenTwoDate(this.dateFin, this.dateDebut)),
      ) + 1;
      const nombreJourLocationEntreDebutFin = Number(
        calculDaysBetweenTwoDate(
          this.ligneRegroupement.dateFin,
          this.ligneRegroupement.dateDebut,
        ),
      ) + 1;
      if (nombreJourEntreDebutFin <= 0 || nombreJourLocationEntreDebutFin <= 0) return;
      this.newQuantite = calculArrondi(
        ligneEnfantLocation.quantite * nombreJourEntreDebutFin / nombreJourLocationEntreDebutFin,
        5,
      );
      this.repercutionModificationQuantite(this.newQuantite);
    },
    updateLigneOriginalWithNewData() {
      this.ligneWithQuantiteEditable
        .filter((ligneEnfantModifie) => {
          return ligneEnfantModifie.quantiteDoitEtreProratise;
        })
        .forEach((ligneEnfantModifie) => {
          const ligneRegroupementDuDCF = this.ligneRegroupement.lignesCommande
            .find((ligneRegroupement) => {
              return ligneRegroupement.ordre === ligneEnfantModifie.ordre;
            });
          if (!ligneRegroupementDuDCF) return;
          ligneRegroupementDuDCF.quantite = ligneEnfantModifie.quantite;
          ligneRegroupementDuDCF.prixUnitaire = ligneEnfantModifie.prixUnitaire;
        });
    },
    async sendEvent() {
      const errors = validationDateLocation(
        this.dateDebut,
        this.dateFin,
        this.ligneRegroupement.typeProduit,
        this.isCommandeBailleur,
      );
      if (errors.length === 0) {
        if (this.prorataTemporisDateQuantite) {
          this.updateLigneOriginalWithNewData();
        }
        if (this.changeDateRenouvellement && this.devisCommande.renouvelable) {
          this.devisCommande.dateRenouvellement = moment(this.dateFin).add(1, 'd').toDate();
        }
        if (moment(this.ligneRegroupement.dateDebut)
          .isSame(moment(this.ligneRegroupement.datePlanifieeLogistiqueAffichage))) {
          this.ligneRegroupement.datePlanifieeLogistiqueAffichage = this.dateDebut;
          if (this.ligneRegroupement.lignesCommande) {
            this.ligneRegroupement.lignesCommande.forEach((ligne) => {
              ligne.datePlanifieeLogistiqueAffichage = this.dateDebut;
            });
          }
        }
        this.ligneRegroupement.dateDebut = this.dateDebut;
        this.ligneRegroupement.dateFin = this.dateFin;
        this.ligneRegroupement.isDeleteTfsAfterEndDate = this.isDeleteTfsAfterEndDate;
        if (this.ligneRegroupement.typeProduit === CATEGORIE_REGROUPEMENT_LC) {
          await mettreAJourLigneReseauAvecDispo(this.ligneRegroupement);
        }
        this.$emit('updatePeriodeLocation', {
          changeDateRenouvellement: this.changeDateRenouvellement,
          prorataTemporisDateQuantite: this.prorataTemporisDateQuantite,
        });
        this.$parent.close();
      }
      if (errors.length > 0) {
        this.isError = true;
        if (this.messagesPopup.length > 0) {
          this.messagesPopup.splice(0, 1, errors[0]);
        } else {
          this.messagesPopup.push(errors[0]);
        }
      }
    },
    formatDate(date) {
      return formatDate(date);
    },
  },
  mounted() {
    if (this.avecMajDateRenouvellement
      && this.devisCommande.lignesCommande
        .filter((ligne) => { return ligne.type === REGROUPEMENT; }).length > 1) {
      this.changeDateRenouvellement = false;
    }
    if (this.ligneRegroupement.calculProrata !== undefined
      && !this.ligneRegroupement.calculProrata) {
      this.isFirstTime = true;
      delete this.ligneRegroupement.calculProrata;
    }
    this.prorataTemporisDateQuantite = !this.isFirstTime && this.devisCommande.role !== REGIE
      && this.devisCommande.type !== TYPE_FACTURE && !this.isFromLogistique;

    const ligneEnfantLocation = this.ligneRegroupement.lignesCommande.find((ligneEnfant) => {
      return ligneEnfant.type === NORMAL && ligneEnfant.typeProduit === LOCATION;
    });
    this.setLigneOfRegroupement(cloneDeep(this.ligneRegroupement.lignesCommande));
    this.newQuantite = cloneDeep(ligneEnfantLocation.quantite);
    this.messagesInformation = this.miseEnformelibelle();
  },
};
</script>
